export default {"src":"/_next/static/media/Telesign.89f572c3.svg","height":60,"width":60};